export const EXPENSE_REQUESTS = {
    TYPES: [
        {
            label: 'Gift',
            technical_name: 'gift',
            value: 'gift',
        },
        {
            label: 'Culture',
            technical_name: 'culture',
            value: 'culture',
        },
        {
            label: 'Sport & Leisure',
            technical_name: 'sport',
            value: 'sport-leisure',
        },
        {
            label: 'Holidays',
            technical_name: 'holidays',
            value: 'holidays',
        },
        {
            label: 'Mobility',
            technical_name: 'mobility',
            value: 'mobility',
        },
        {
            label: 'Subscription ticket',
            technical_name: 'subscription_ticket',
            value: 'mobility-subscription-ticket',
        },
        {
            label: 'Bicyle shop',
            technical_name: 'bicycle_shop',
            value: 'mobility-bicycle-shop',
        },
        {
            label: 'Bicycle service',
            technical_name: 'bicycle_service',
            value: 'mobility-bicycle-service',
        },
        {
            label: 'Carpooling',
            technical_name: 'carpooling_app',
            value: 'mobility-carpooling',
        },
        {
            label: 'Carsharing',
            technical_name: 'carsharing',
            value: 'mobility-carsharing',
        },
        {
            label: 'Electric vehicle recharging',
            technical_name: 'electric_vehicle_recharge',
            value: 'mobility-electric-vehicle-recharge',
        },
        {
            label: 'Fuel expenses',
            technical_name: 'fuel_expenses',
            value: 'fuel-expenses',
        },
    ],
};
